import React from "react";
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { useAuth } from "../context/authContext";
import { AddAdmin, Admins } from "../views/admins";
import { AddReview, Reviews } from "../views/reviews";
import Dashboard from "../views/dashboard";
import Login from "../views/login";
import MyAccount from "../views/myaccount";
import { AddProductCategory, ProductCategories } from "../views/product-categories";
import { AddProductSubCategory, ProductSubCategories } from "../views/product-sub-categories";
import { AddImage, AddProduct, ProductGallery, Products } from "../views/products";
import { AddUser } from "../views/users/AddUser";
import { Users } from "../views/users/Users";
import Attributes from "../views/attributes";
import { AddBrand, Brands } from "../views/brands";
import { AddProductCategoryBar, ProductCategoriesBars } from "../views/product-categories-bar";

import { Finish } from "../views/attributes/finish/Finish";
import { AddFinish } from "../views/attributes/finish/AddFinish";
import { AddSize, Sizes } from "../views/attributes/size";
import { AddStorage, Storages } from "../views/attributes/storage";
import { AddProductConfig, ProductConfigs } from "../views/productConfigs";
import { Orders } from "../views/orders/Orders";
import { City } from "../views/city";
import { AddCity } from "../views/city/AddCity";
import { AddColor, Colors } from "../views/attributes/color";
import { AddUserType, UserTypes } from "../views/user-types";
import { Analytics } from "../views/analytics";
import { Slider } from "../views/sliders/Slider";
import { AddSlider } from "../views/sliders/AddSlider";
import { AddSliderImages } from "../views/sliders";
import { Store } from "../views/store/Store";
import { AddStore } from "../views/store/AddStore";
import { OrderDetails } from "../views/orders";
import { AddBlog, Blog } from "../views/blogs";
import { Testimonial } from "../views/testimonials/Testimonials";
import { AddTestimonial } from "../views/testimonials/AddTestimonial";
import { Materials } from "../views/attributes/material/Materials";
import { AddMaterial } from "../views/attributes/material/AddMaterial";
import Example from "../views/trial";

export default function Routing() {
  const { currentUser } = useAuth();

  if (currentUser) {
    return (
      <Routes>
        {/* <Route path="/" element={<Dashboard/>} /> */}
        <Route exact path="/billing" element={<Example/>} />

        <Route exact path="/dashboard" element={<Dashboard/>} />

        <Route exact path="/admins" element={<Admins/>} />
        <Route exact path="/add-admin" element={<AddAdmin/>} />
        <Route exact path="/update-admin" element={<AddAdmin/>} />

        <Route exact path="/my-account" element={<MyAccount/>} />

        <Route exact path="/orders" element={<Orders/>} />
        <Route exact path="/order-details" element={<OrderDetails/>} />

        <Route exact path="/analytics" element={<Analytics/>} />
        
        <Route exact path="/users" element={<Users/>} />
        <Route exact path="/add-user" element={<AddUser/>} />
        <Route exact path="/update-user" element={<AddUser/>} />
        
        <Route exact path="/testimonials" element={<Testimonial/>} />
        <Route exact path="/add-testimonial" element={<AddTestimonial/>} />
        <Route exact path="/update-testimonial" element={<AddTestimonial/>} />
        
        <Route exact path="/city" element={<City/>} />
        <Route exact path="/add-city" element={<AddCity/>} />
        <Route exact path="/update-city" element={<AddCity/>} />
        
        <Route exact path="/blog" element={<Blog/>} />
        <Route exact path="/add-blog" element={<AddBlog/>} />
        <Route exact path="/update-blog" element={<AddBlog/>} />
        
        <Route exact path="/store" element={<Store/>} />
        <Route exact path="/add-store" element={<AddStore/>} />
        <Route exact path="/update-store" element={<AddStore/>} />
        
        <Route exact path="/slider" element={<Slider/>} />
        <Route exact path="/add-slider" element={<AddSlider/>} />
        <Route exact path="/add-slider-images" element={<AddSliderImages/>} />
        <Route exact path="/update-slider" element={<AddSlider/>} />
        
        <Route exact path="/brands" element={<Brands/>} />
        <Route exact path="/add-brand" element={<AddBrand/>} />
        <Route exact path="/update-brand" element={<AddBrand/>} />
        
        <Route exact path="/user-types" element={<UserTypes/>} />
        <Route exact path="/add-user-type" element={<AddUserType/>} />
        <Route exact path="/update-user-type" element={<AddUserType/>} />
        
        <Route exact path="/attributes" element={<Attributes/>} />
        
        <Route exact path="/finishes" element={<Finish/>} />
        <Route exact path="/add-finish" element={<AddFinish/>} />
        <Route exact path="/update-finish" element={<AddFinish/>} />
        
        <Route exact path="/sizes" element={<Sizes/>} />
        <Route exact path="/add-size" element={<AddSize/>} />
        <Route exact path="/update-size" element={<AddSize/>} />
        
        <Route exact path="/storages" element={<Storages/>} />
        <Route exact path="/add-storage" element={<AddStorage/>} />
        <Route exact path="/update-storage" element={<AddStorage/>} />
        
        <Route exact path="/colors" element={<Colors/>} />
        <Route exact path="/add-color" element={<AddColor/>} />
        <Route exact path="/update-color" element={<AddColor/>} />
        
        <Route exact path="/materials" element={<Materials/>} />
        <Route exact path="/add-material" element={<AddMaterial/>} />
        <Route exact path="/update-material" element={<AddMaterial/>} />
        
        <Route exact path="/product-categories-bars" element={<ProductCategoriesBars/>} />
        <Route exact path="/add-product-category-bar" element={<AddProductCategoryBar/>} />
        <Route exact path="/update-product-category-bar" element={<AddProductCategoryBar/>} />
        
        <Route exact path="/product-categories" element={<ProductCategories/>} />
        <Route exact path="/add-product-category" element={<AddProductCategory/>} />
        <Route exact path="/update-product-category" element={<AddProductCategory/>} />
        
        <Route exact path="/product-sub-categories" element={<ProductSubCategories/>} />
        <Route exact path="/add-product-sub-category" element={<AddProductSubCategory/>} />
        <Route exact path="/update-product-sub-category" element={<AddProductSubCategory/>} />
        
        <Route exact path="/products" element={<Products/>} />
        <Route exact path="/add-product" element={<AddProduct/>} />
        <Route exact path="/update-product" element={<AddProduct/>} />
        
        <Route exact path="/product-configs" element={<ProductConfigs/>} />
        <Route exact path="/add-product-config" element={<AddProductConfig/>} />
        <Route exact path="/update-product-config" element={<AddProductConfig/>} />
        
        <Route exact path="/reviews" element={<Reviews/>} />
        <Route exact path="/add-review" element={<AddReview/>} />
        <Route exact path="/update-review" element={<AddReview/>} />

        <Route exact path="/add-product-image" element={<AddImage/>} />
        <Route exact path="/product-image-gallery" element={<ProductGallery/>} />

        <Route path="/*" element={<Navigate replace to="/dashboard" />} />
        

      </Routes>
    )
  } else {
    return (
      <Routes>
        <Route exact path="/" element={<Login/>} />
        <Route path="/*" element={<Navigate replace to="/" />} />
      </Routes>
    );
  }
}